import { type GridColumnVisibilityModel } from '@mui/x-data-grid';

export const PAGE_FOCUS_MODES = ['promo', 'voucher', 'channel-markup', 'all'] as const;

export type PageFocusMode = (typeof PAGE_FOCUS_MODES)[number];

function isPageFocusMode(value: string | null | undefined): value is PageFocusMode {
  return typeof value === 'string' && PAGE_FOCUS_MODES.some((mode) => mode === value);
}

export function parsePageFocusMode(value: string | null | undefined): PageFocusMode {
  return isPageFocusMode(value) ? value : 'all';
}

/**
 * Focused pages retain the contextual columns and hide the two unrelated
 * identifier groups. Users can still opt back in through the column selector.
 */
export function getFocusColumnVisibility(
  pageFocusMode: PageFocusMode,
  fields: { promo?: string; voucher?: Array<string>; channelMarkup?: Array<string> },
): GridColumnVisibilityModel {
  switch (pageFocusMode) {
    case 'promo':
      return Object.fromEntries(
        [...(fields.voucher ?? []), ...(fields.channelMarkup ?? [])].map((field) => [field, false]),
      );
    case 'voucher':
      return Object.fromEntries(
        [fields.promo, ...(fields.channelMarkup ?? [])].filter(Boolean).map((field) => [field, false]),
      );
    case 'channel-markup':
      return Object.fromEntries(
        [fields.promo, ...(fields.voucher ?? [])].filter(Boolean).map((field) => [field, false]),
      );
    case 'all':
      return {};
  }
}
